import OtmBase from "./otm/OtmBase";
import getOtmSismac from "../../services/equipment/getOtmSismac";

const OtmSismac = ({ codigo }) => {
  if (!codigo) return null; // evita render si no hay código

  return (
    <OtmBase
      fetchFn={() => getOtmSismac(codigo).then((res) => res.otmSismac)}
      cardStyle="card-primary"
      titulo="OTMs SISMAC"
    />
  );
};

export default OtmSismac;
